module.exports = __webpack_public_path__ + "static/media/2023_17.37def53d.jpg";